import React from 'react';

import { Box, Text } from '@opendoor/bricks-next';
import { IconChevronLeft } from '@tabler/icons-react';

interface MobileSubMenuBackButtonProps {
  onClick: () => void;
}

export const MobileSubMenuBackButton: React.FC<MobileSubMenuBackButtonProps> = ({ onClick }) => {
  const buttonProps = { onPress: onClick } as any;

  return (
    <Box
      {...buttonProps}
      tag="button"
      aria-label="Back"
      alignItems="left"
      cursor="pointer"
      paddingTop="$8x"
      paddingBottom="$6x"
      paddingLeft="$12x"
      paddingRight="$8x"
    >
      <Text tag="span" typography="$bodySmall" color="$contentPrimary">
        <IconChevronLeft size={24} />
      </Text>
    </Box>
  );
};
